import Cookies from 'js-cookie';

export const getLocale = () => Cookies.get('locale') || 'en';
export const setLocale = locale => Cookies.set('locale', locale);
